<div class="row margin-top-bottom-20px">
  <div class="col-9">
    <h2>
      <i class="fas fa-address-book"></i> Migration history for
      <strong>
        <a routerLink="/au/accounts/{{ accountId }}">
          {{ accountId }}
        </a>
      </strong>
      with data from
      <strong>
        {{ proAccountId }}
      </strong>
    </h2>
  </div>
</div>

<migrations-account
  [migrations]="migrations$ | async"
  [progress]="migrationsProgress$ | async"
  [progressIsLoading]="progressIsLoading$ | async"
  [isLoadingMigrations]="isLoadingMigrations$ | async"
  [pasMigrationsProgress]="pasMigrationsProgress$ | async"
  [pasProgressIsLoading]="pasProgressIsLoading$ | async"
  (changeChartPeriod)="changeDateRange($event)"
  (updateMigrationProgress)="updateMigrationProgress($event)"
  (openMigrationModal)="openMigrationModal($event)"
  (getMigrationReport)="getMigrationReport($event)"
>
</migrations-account>
